import { DATE_WITH_TIME_FORMAT } from '@utils/constants';
import dayjs from 'dayjs';

import { assigns } from './constants';

export const generateDateParam = ({
  i,
  paramStartDate,
  paramFinishDate
}: {
  i: string;
  paramStartDate?: string | null;
  paramFinishDate?: string | null;
}): Record<
  string,
  {
    start: string | null;
    finish: string | null;
  }
> => {
  const finishDate = dayjs(assigns[i]?.finishDate, DATE_WITH_TIME_FORMAT).endOf('day');
  const startDate = dayjs(assigns[i]?.startDate, DATE_WITH_TIME_FORMAT).startOf('day');

  const finishDateParam = dayjs(finishDate, DATE_WITH_TIME_FORMAT).endOf('day');
  const startDateParam = dayjs(startDate, DATE_WITH_TIME_FORMAT).startOf('day').add(-1, 'minute');

  return {
    Otib_ketgan: {
      start: paramStartDate || assigns[i]?.startDate,
      finish:
        finishDateParam.diff(finishDate, 'day') >= 0
          ? assigns[i]?.finishDate
          : paramFinishDate || assigns[i]?.finishDate
    },
    Rejada: {
      start:
        startDateParam.diff(startDate, 'day') <= 0 ? assigns[i]?.startDate : paramStartDate || assigns[i]?.startDate,
      finish: paramFinishDate || assigns[i]?.finishDate
    },
    Bugungi: {
      start: assigns[i]?.startDate,
      finish: assigns[i]?.finishDate
    },
    Ertangi: {
      start: assigns[i]?.startDate,
      finish: assigns[i]?.finishDate
    }
  };
};

export const isSendTaskReq = ({
  i,
  paramStartDate,
  paramFinishDate
}: {
  i: string;
  paramStartDate?: string | null;
  paramFinishDate?: string | null;
}) => {
  const finishDate = dayjs(assigns[i]?.finishDate, DATE_WITH_TIME_FORMAT).endOf('day');
  const startDate = dayjs(assigns[i]?.startDate, DATE_WITH_TIME_FORMAT).startOf('day');

  const finishDateParam = dayjs(finishDate, DATE_WITH_TIME_FORMAT).endOf('day');
  const startDateParam = dayjs(startDate, DATE_WITH_TIME_FORMAT).startOf('day').add(-1, 'minute');

  if (i === 'Otib_ketgan') {
    return startDateParam.diff(finishDate, 'day') < 0 || (!paramStartDate && !paramFinishDate);
  }

  if (i === 'Bugungi') {
    return (
      (startDate.diff(startDateParam, 'day') >= 0 && finishDate.diff(finishDateParam, 'day') <= 0) ||
      (!paramStartDate && !paramFinishDate)
    );
  }

  if (i === 'Ertangi') {
    return (
      (startDate.diff(startDateParam, 'day') >= 0 && finishDate.diff(finishDateParam, 'day') <= 0) ||
      (!paramStartDate && !paramFinishDate)
    );
  }

  if (i === 'Rejada') {
    return finishDateParam.diff(startDate, 'day') >= 0 || (!paramStartDate && !paramFinishDate);
  }

  return false;
};

const retrieveMondayDate = (date = new Date()) => {
  const clonedDate = new Date(date.getTime());

  return clonedDate.setDate(clonedDate.getDate() + ((1 + 7 - clonedDate.getDay()) % 7 || 7));
};

const nextMonday = new Date(retrieveMondayDate());

export const nextMondayFormat = nextMonday.toLocaleString('ru').replace(',', '').substring(0, 10);

export const nextMondayStart = `${nextMondayFormat} 00:00`;
export const nextMondayFinish = `${nextMondayFormat} 23:59`;
